var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-app-bar',{attrs:{"app":"","dark":"","flat":""}},[_c('v-btn',{staticClass:"mr-2",attrs:{"to":"/","text":""}},[_vm._v("🧠 ARK Invest Trades")]),_c('v-spacer'),_c('TheUserIcon')],1),_c('v-main',[_c('Uid',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var uid = ref.uid;
return [_c('router-view')]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }